import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { CiCirclePlus } from "react-icons/ci";
import { toast } from "react-toastify";
import apiService from "../../services/apiService.js";

import "./UsersList.css";
import { useNavigate } from "react-router-dom";
import { Dots } from "../../assets/svg.js";
import ConfiramtionModal from "../Users/ConfiramtionModal.js";
import CustomPaginationformoh from "../../components/common/custompagination/CustomPagination";

const UsersList = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [users, setUsers] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const [confirmationModal, setConfirmationModal] = useState({
    action: "",
    userId: "",
  });

  const navigate = useNavigate();

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleDropdown = (index) => {
    setDropdownOpen((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };

  const fetchFilteredUsers = async (page, rowsPerPage) => {
    try {
      const response = await apiService.get(
        `user/allUsers?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );

      if (response?.data?.data?.length) {
        setUsers(response.data?.data);
        setTotalRows(response?.data?.total);
      } else {
        setUsers([]);
      }
    } catch (e) {
      console.log("Error fetching users:", e);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 2000);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (debouncedQuery !== "") {
      fetchFilteredUsers(debouncedQuery);
    } else {
      setUsers([]);
    }
  }, [debouncedQuery]);
  useEffect(() => {
    fetchFilteredUsers(page, rowsPerPage);
  }, [refresh, page, rowsPerPage]);

  const deleteUser = async (id) => {
    try {
      const response = await apiService.post("user/delete", { id });

      if (response?.data) {
        toast.success(response?.message || "User deleted successfully!", {
          toastId: "12",
        });
        handleRefresh();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = () => {
    setConfirmationModal({ action: "", userId: "" });
  };

  const handleSubmit = async () => {
    if (confirmationModal.userId && confirmationModal.action === "delete") {
      deleteUser(confirmationModal.userId);
      setConfirmationModal({ action: "", userId: "" });
    }
  };

  const data = Array(10).fill({
    userId: "TR56367",
    arabicName: "عبد الرحمن بن عبد الله القرضي",
    englishName: "Abdul Rahman Bin Abdullah Al-Quradi",
    specialty: "Cardiologist",
    contractType: "FT",
    status: "Pending",
  });

  return (
    <div className="">
      {/* Header Section */}
      <div className="flex justify-content-between align-items-center p-4 bg-gray-100 h-[60px]">
        <div className="relative  w-[300px] me-3">
          <input
            type="search"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full py-2 pr-10 pl-3 border border-gray-300 rounded-md text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary"
          />
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-4.35-4.35M16.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z"
              />
            </svg>
          </div>
        </div>

        <div className="grid grid-cols-2 divide-x-4">
          <div className="d-flex align-items-center justify-end	">
            {/* <Button color="light" className="me-2 opacity-20	">
              <BiTrash className="text-xl	" />
            </Button> */}
            <Button color="light" className="me-3 ">
              <CiCirclePlus
                className="text-xl"
                onClick={() => {
                  navigate("/user-add");
                }}
              />
            </Button>
          </div>
          <div className="mt-2 pl-2">Total Count: {users.length}</div>
        </div>
      </div>

      {/* Tabs Section 
        
        
          <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === "all" ? "active" : ""}
            style={{
              position: "relative",
              color: activeTab === "all" ? "gray" : "inherit",
            }}
            onClick={() => toggleTab("all")}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px", // Adds spacing between name and badge
              }}
            >
              All Users
            </span>
            {activeTab === "all" && (
              <div
                style={{
                  position: "absolute",
                  bottom: "-2px",
                  left: "0",
                  right: "0",
                  height: "2px",
                  backgroundColor: "gray",
                }}
              ></div>
            )}
          </NavLink>
        </NavItem>


      </Nav>
        */}

      <div className="pt2"></div>

      {/* Data Table */}
      <Table hover responsive>
        <thead>
          <tr>
            {/* <th>
              <Input type="checkbox" />
            </th> */}
            <th>User ID</th>

            <th>English Name</th>
            <th>Email</th>
            <th>Role</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((item, index) => (
            <tr key={index}>
              {/* <td>
                <Input type="checkbox" />
              </td> */}
              <td>{index + 1 || "-"}</td>

              <td>{item.firstName}</td>
              <td>{item.email}</td>
              <td>
                {item?.role?.name == "Cluster_Manager"
                  ? "Cluster Manager"
                  : item?.role?.name || "-"}{" "}
              </td>
              {/* <td>
                <span className={`badge bg-warning`}>{item.status}</span>
              </td> */}
              <td>
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Dots
                    style={{ cursor: "pointer", marginRight: "8px" }}
                    onClick={() => toggleDropdown(index)}
                  />

                  <Dropdown
                    isOpen={dropdownOpen[index] || false}
                    toggle={() => toggleDropdown(index)}
                    style={{ position: "absolute", top: 0, left: "-150px" }}
                  >
                    {/* <DropdownToggle caret color="secondary">
                    Actions
                  </DropdownToggle> */}
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          navigate(`/user-edit/${item._id}`);
                        }}
                      >
                        Edit
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          setConfirmationModal({
                            action: "delete",
                            userId: item._id,
                          });
                        }}
                        // onClick={() => {
                        //   deleteUser(item._id);
                        // }}
                      >
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <CustomPaginationformoh
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalRows={totalRows}
      />

      {/* Pagination Section */}
      {/* <div className="d-flex justify-content-between align-items-center mt-3">
        <span>Total Count: 5591</span>
        <Pagination>
          <PaginationItem>
            <PaginationLink previous href="#" />
          </PaginationItem>
          {[1, 2, 3].map((page) => (
            <PaginationItem active={page === 1} key={page}>
              <PaginationLink href="#">{page}</PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem>
            <PaginationLink next href="#" />
          </PaginationItem>
        </Pagination>
      </div> */}
      {confirmationModal.action !== "" && (
        <ConfiramtionModal
          confirmationAction={confirmationModal}
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default UsersList;
